import { render, staticRenderFns } from "./LegoDropzone.vue?vue&type=template&id=0d155a8d"
import script from "./LegoDropzone.vue?vue&type=script&lang=js"
export * from "./LegoDropzone.vue?vue&type=script&lang=js"
import style0 from "./LegoDropzone.vue?vue&type=style&index=0&id=0d155a8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports